const DISABLE_REVALIDATION_OPTIONS = {
  revalidateOnFocus: false,
  revalidateOnMount: false,
  revalidateOnReconnect: false,
  revalidateIfStale: false,
  refreshWhenOffline: false,
  refreshWhenHidden: false,
  refreshInterval: 0,
}

export default DISABLE_REVALIDATION_OPTIONS
